@if (isOpen) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-[85%] max-h-[90vh] flex flex-col overflow-hidden">

        <div class="flex items-center justify-between p-6 border-b border-gray-100">
            <h2 class="text-xl font-bold text-gray-900">{{ translate.instant('EDIT_TRANSACTION.HEADER.TITLE') }}</h2>
            <button (click)="closeModal()" class="p-2 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors">
                <app-delete-item [width]="20" [height]="20"></app-delete-item>
            </button>
        </div>

        <!-- Filters -->
        <div class="p-6 bg-gray-50 flex flex-wrap items-end gap-6 border-b border-gray-200">
            <div class="w-52 min-w-[200px] max-w-xs">
                <label class="block text-sm text-gray-500 mb-1">{{
                    translate.instant('EDIT_TRANSACTION.FILTERS.SEARCH_PLACEHOLDER') }}</label>
                <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-gray-400">
                            <circle cx="11" cy="11" r="8" />
                            <path d="m21 21-4.3-4.3" />
                        </svg>
                    </div>
                    <input type="text" (input)="onSearch($event)"
                        class="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm"
                        [placeholder]="translate.instant('EDIT_TRANSACTION.FILTERS.SEARCH_PLACEHOLDER')">
                </div>
            </div>

            <div class="w-52 min-w-[200px]">
                <label class="block text-sm text-gray-500 mb-1">{{ translate.instant('EDIT_TRANSACTION.FILTERS.STATUS')
                    }}</label>
                <select
                    class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md border text-gray-900 bg-gray-50"
                    (change)="onStatusChange($event)" [value]="statusTerm">
                    <option value="NO_CLASSIFIED_ONLY">{{
                        translate.instant('EDIT_TRANSACTION.FILTERS.NO_CLASSIFIED_ONLY') }}</option>
                    <option value="CLASSIFIED">{{ translate.instant('EDIT_TRANSACTION.FILTERS.CLASSIFIED') }}</option>
                    <option value="ALL">{{ translate.instant('EDIT_TRANSACTION.FILTERS.ALL') }}</option>
                </select>
            </div>

            @for (field of filterableFields; track field) {
            <div class="w-52 min-w-[200px]">
                <label class="block text-sm text-gray-500 mb-1 capitalize">{{ field }}</label>
                <ng-select [items]="filterOptionsMap[field]" [(ngModel)]="selectedFieldFilters[field]" [multiple]="true"
                    [searchable]="true" [clearable]="true" [placeholder]="'Filtrer par ' + field"
                    (change)="onFilterChange(field)" [loading]="filterOptionsMap[field].length < 0"
                    [readonly]="filterOptionsMap[field].length < 0" class="w-full text-sm font-normal" appendTo="body">
                </ng-select>
            </div>
            }

            <div class="flex-1 flex justify-end min-w-[200px]">
                <span class="text-xs text-gray-500">{{ filteredResults.length }} / {{ results.length }}
                    transactions</span>
            </div>
        </div>
        <!-- warning -->
        @if (hasModifications) {
        <div id="modification-banner" class="px-6 py-3 bg-amber-50 border-b border-amber-300 text-sm block">
            <div class="mb-1 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#d97706"
                    stroke="#d97706" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-triangle-alert-icon lucide-triangle-alert">
                    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" fill="#ffffff" />
                    <path d="M12 9v4" />
                    <path d="M12 17h.01" />
                </svg>
                <strong>{{ translate.instant('EDIT_TRANSACTION.MODIFICATIONS_DETECTED') }}</strong>
            </div>
            <div class="text-xs text-gray-500" id="banner-detail">{{ numberTransactionsModified() }} {{
                translate.instant('EDIT_TRANSACTION.TABLE.FOOTER.TRANSACTIONS_MODIFIED') }} - {{
                translate.instant('EDIT_TRANSACTION.TABLE.FOOTER.BUNDLE_MUST_BE_REPLAYED') }}
            </div>
        </div>
        }
        <div class="flex-1 overflow-auto">
            <cdk-virtual-scroll-viewport itemSize="20" class="viewport">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50 z-10 shadow-sm">
                        <tr>
                            <th scope="col"
                                class="flex flex-row items-center gap-1  px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider cursor-pointer">
                                <button (click)="onShowReference.set(!onShowReference())"
                                    [title]="onShowReference() ? translate.instant('EDIT_TRANSACTION.TABLE.HEADER.TRUNCATED_REFERENCES') : translate.instant('EDIT_TRANSACTION.TABLE.HEADER.FULL_REFERENCES')">
                                    <app-list-chevrons-up-down></app-list-chevrons-up-down>
                                </button>
                                <div class="flex flex-row items-center gap-1 cursor-pointer"
                                    (click)="onSort('reference')">
                                    {{ translate.instant('EDIT_TRANSACTION.TABLE.HEADER.REFERENCE') }}
                                    <app-sort-icon [order]="onOrderReference"
                                        [title]="onOrderReference === 'asc' ? translate.instant('EDIT_TRANSACTION.TABLE.HEADER.ASCENDING') : translate.instant('EDIT_TRANSACTION.TABLE.HEADER.DESCENDING')"></app-sort-icon>
                                </div>

                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider cursor-pointer">
                                <div class="flex items-center gap-1" (click)="onSort('date')">
                                    {{ translate.instant('EDIT_TRANSACTION.TABLE.HEADER.DATE') }}
                                    <app-sort-icon [order]="onOrderDate"
                                        [title]="onOrderDate === 'asc' ? translate.instant('EDIT_TRANSACTION.TABLE.HEADER.ASCENDING') : translate.instant('EDIT_TRANSACTION.TABLE.HEADER.DESCENDING')"></app-sort-icon>
                                </div>

                            </th>
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider cursor-pointer">
                                <div class="flex items-center gap-1" (click)="onSort('amount')">
                                    {{ translate.instant('EDIT_TRANSACTION.TABLE.HEADER.AMOUNT') }}
                                    <app-sort-icon [order]="onOrderAmount"
                                        [title]="onOrderAmount === 'asc' ? translate.instant('EDIT_TRANSACTION.TABLE.HEADER.ASCENDING') : translate.instant('EDIT_TRANSACTION.TABLE.HEADER.DESCENDING')"></app-sort-icon>
                                </div>

                            </th>
                            @for (col of selectedAdditionalInfos; track col.label) {
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider cursor-pointer">
                                <div class="flex items-center gap-1" (click)="onOptionalFieldSort(col)">
                                    {{ col.label }}
                                    <app-sort-icon
                                        [title]="col.key === 'asc' ? translate.instant('EDIT_TRANSACTION.TABLE.HEADER.ASCENDING') : translate.instant('EDIT_TRANSACTION.TABLE.HEADER.DESCENDING')"
                                        [order]="additionalColumnsSort[col.label] || 'desc'"></app-sort-icon>
                                </div>
                            </th>

                            }
                            <th scope="col"
                                class="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider">
                                <div class="relative inline-block">
                                    <app-dropdown-additional-info-icon (click)="toggleDropdownAdditionalInfos($event)"
                                        cdkOverlayOrigin #trigger="cdkOverlayOrigin"
                                        class="cursor-pointer hover:opacity-80 transition-opacity inline-block"
                                        [title]="translate.instant('EDIT_TRANSACTION.TABLE.HEADER.SHOW_OPTIONAL_FIELDS')"></app-dropdown-additional-info-icon>

                                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger"
                                        [cdkConnectedOverlayOpen]="dropdownVisible"
                                        (overlayOutsideClick)="dropdownVisible = false" [cdkConnectedOverlayPositions]="[
                                            { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 }
                                        ]">
                                        <div
                                            class="bg-white min-w-[220px] max-h-60 shadow-lg rounded-xl border border-gray-100 z-50 overflow-y-auto">
                                            <form [formGroup]="additionalInfosForm" class="p-2 flex flex-col gap-1">
                                                @for (column of additionalColumns; track column.label) {
                                                <label
                                                    class="flex items-center gap-3 px-3 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded-lg cursor-pointer transition-colors">
                                                    <input type="checkbox" [checked]="column.show"
                                                        (change)="onCheckAdditionalInfo(column, $event)"
                                                        class="w-4 h-4 accent-primary text-primary bg-white border-gray-300 rounded focus:ring-primary cursor-pointer transition-shadow" />
                                                    <span class="select-none font-medium text-sm capitalize">{{
                                                        column.label
                                                        }}</span>
                                                </label>
                                                }
                                                @if (additionalColumns.length === 0) {
                                                <div class="px-3 py-4 text-sm text-center text-gray-500 italic">
                                                    Aucune information
                                                </div>
                                                }
                                            </form>
                                        </div>
                                    </ng-template>
                                </div>
                            </th>
                            <!-- <th scope="col"
                                class="px-6 py-3 text-left text-xs font-bold text-gray-600 uppercase tracking-wider">
                                <div class="flex items-center gap-1">
                                    {{ translate.instant('EDIT_TRANSACTION.TABLE.HEADER.RECONCILIATION') }}
                                </div>
                            </th> -->
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                        <tr class="hover:bg-gray-50 transition-colors" *cdkVirtualFor="let tx of filteredResults">
                            <td class="px-6 py-4 whitespace-nowrap text-sm" [title]="tx.reference">
                                <div class="flex items-center gap-1 flex-nowrap">
                                    <app-copy-item [item]="getReferenceDisplayValue(tx.reference)"></app-copy-item>
                                    @if(tx.isModified) {
                                    <app-hand-icon></app-hand-icon>
                                    }
                                </div>
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm">
                                {{ tx.date }}
                            </td>
                            <td class="px-6 py-4 whitespace-nowrap text-sm">
                                {{ tx.amount }}
                            </td>
                            @for (col of selectedAdditionalInfos; track col.label) {
                            <td class="px-6 py-4 whitespace-nowrap text-sm">
                                @if (editableBundleFields?.[col.label] &&
                                editableBundleFields[col.label].validation_rule === 'instance_belongs_to_client') {
                                <div class="relative w-full max-w-[240px]">
                                    <ng-select [items]="optionsMap[col.label]" bindLabel="name" bindValue="name"
                                        (change)="selectData($event, tx, col.label)"
                                        [(ngModel)]="tx.additionalInfos[col.label]" [searchable]="true"
                                        [clearable]="false" [disabled]="saving" class="w-full text-sm" appendTo="body">
                                    </ng-select>


                                    @if(isRowModified(tx, col.label)) {
                                    <div class="absolute -right-1.5 -top-1.5 z-10 transition-all duration-300">
                                        @if(saving) {
                                        <div
                                            class="bg-white rounded-full shadow border border-gray-100 p-0.5 flex flex-col items-center justify-center">
                                            <app-loading-spinner width="w-3.5" height="h-3.5"></app-loading-spinner>
                                        </div>
                                        } @else {
                                        <span class="flex h-3 w-3"
                                            [title]="translate.instant('EDIT_TRANSACTION.TABLE.BODY.MODIFICATION_PENDING')">
                                            <span
                                                class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                                            <span
                                                class="relative inline-flex rounded-full h-3 w-3 bg-primary border border-white"></span>
                                        </span>
                                        }
                                    </div>
                                    }
                                </div>
                                } @else {
                                {{ tx.additionalInfos?.[col.label] || '' }}
                                }
                            </td>
                            }
                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            </td>
                            <!-- <td class="px-6 py-4 whitespace-nowrap">
                                <span
                                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800 border border-green-200 truncate max-w-[250px]"
                                    [title]="tx.reconciliation">
                                    {{ tx.reconciliation }}
                                </span>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
                @if(loading){
                <div class="w-full flex justify-center m-2">
                    <app-loading-spinner></app-loading-spinner>
                </div>
                }
            </cdk-virtual-scroll-viewport>
        </div>

        <div class="flex items-center justify-between p-4 border-t border-gray-200 bg-gray-50 mt-auto">
            <div class="flex text-xs text-gray-500 flex-col">
                <span class="text-xs text-gray-500">{{ filteredResults.length }} / {{ results.length }}
                    transactions</span>
                <span class="text-xs text-gray-500">{{ numberTransactionsModified() }} {{
                    translate.instant('EDIT_TRANSACTION.TABLE.FOOTER.TRANSACTIONS_MODIFIED') }}
                    @if(numberTransactionsModified() > 0) { - {{
                    translate.instant('EDIT_TRANSACTION.TABLE.FOOTER.BUNDLE_MUST_BE_REPLAYED') }} } </span>
            </div>
            <div class="flex gap-3">
                <button (click)="closeModal()"
                    class="px-4 py-2 bg-gray-200 text-gray-800 rounded-md text-sm font-medium hover:bg-gray-300 transition-colors shadow-sm">
                    {{ translate.instant('EDIT_TRANSACTION.TABLE.FOOTER.CANCEL') }}
                </button>
                <button (click)="editTransactionsModal()" [disabled]="saving || hasModifications === false"
                    class="px-4 py-2 bg-primary-800 text-white rounded-md text-sm font-medium hover:bg-primary/90 transition-colors shadow-sm disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2">
                    @if (saving) {
                    <app-loading-spinner width="w-4" height="h-4"></app-loading-spinner>
                    {{ translate.instant('EDIT_TRANSACTION.TABLE.FOOTER.SAVING') }}
                    } @else {
                    {{ translate.instant('EDIT_TRANSACTION.TABLE.FOOTER.SAVE') }}
                    }
                </button>
            </div>
        </div>
    </div>
</div>
}